module.exports = __webpack_public_path__ + "static/media/(000045).b2909715.jpg";